import React, { FC } from 'react';
import { Stack, Typography, useTheme } from '@mui/material';
import boddVariables from '../../../../variables.module.scss';

interface SummaryTableRowComponentProps {
    label: string;
    value: string | React.ReactNode;
    isBoddOnly?: boolean;
}

const SummaryTableRowComponent: FC<SummaryTableRowComponentProps> = (props) => {
    const { label, value, isBoddOnly } = props;
    const theme = useTheme();

    return (
        <Stack
            data-testid="SummaryTableRowComponent"
            direction="row"
            spacing="16px"
            sx={{
                width: '100%',
                minHeight: '24px',
                backgroundColor: isBoddOnly ? `${theme.palette.brandPink.main}26` : 'transparent',
            }}
        >
            <Typography
                sx={{
                    color: boddVariables.boddBlack,
                    fontWeight: 600,
                    letterSpacing: '0.4px',
                    flex: 1,
                }}
            >
                {label}
            </Typography>
            {typeof value === 'string' ? (
                <Typography
                    sx={{
                        color: boddVariables.boddBlack,
                        fontWeight: 400,
                        letterSpacing: '0.15px',
                        flex: 1,
                        wordBreak: 'break-word',
                    }}
                >
                    {value}
                </Typography>
            ) : (
                <div style={{ flex: 1 }}>{value}</div>
            )}
        </Stack>
    );
};

SummaryTableRowComponent.defaultProps = {
    isBoddOnly: false,
};

export default SummaryTableRowComponent;
